module.exports = __webpack_public_path__ + "static/img/step-1011.3b914a3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tutorial/sery/step-1011.png
// module id = ivW/
// module chunks = 1